/** @format */

import React, { useState } from 'react'

import { notification, Modal, Form, Input, Row, Col, Button, Image } from 'antd'
import { CheckOutlined, RightOutlined, LeftOutlined, DeleteFilled } from '@ant-design/icons'

import ProductImage from './components/ProductImage'

import './style.css'

import { serviceSearchProduct } from './services'

export default function SearchProductAction(props) {
	const [form] = Form.useForm()
	const [groupProduct, setGroupProduct] = useState([])
	const [searchList, setSearchList] = useState([])
	const [productsList, setProductsList] = useState([])

	const handleSearchList = async ({ target: { value } }) => {
		const checkRepeat = (str) => {
			const repeats = /(.)\1/
			return repeats.test(str)
		}
		const containsSpecialChars = (str) => {
			const specialChars = /\[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/ //eslint-disable-line
			return specialChars.test(str)
		}

		if (
			value?.length > 3 &&
			value?.length % 2 === 0 &&
			!checkRepeat(value) &&
			!containsSpecialChars(value)
		) {
			let response = await serviceSearchProduct({ value, pharmacy: props.pharmacy })
			setSearchList(response)
		} else {
			setSearchList([])
		}
	}

	const handleCleanList = (item) => {
		setSearchList([])
		setProductsList((previousState) => [...previousState, { ...item, quantity: 0 }])
	}
	const handleDeleteProduct = async (item) => {
		const copyList = [...productsList]
		const index = copyList.findIndex((search) => {
			let searchId = search.id || search.objectID
			return searchId === item.id
		})
		copyList.splice(index, 1)
		setProductsList(copyList)
	}

	const handleAddGroup = (item) => {
		let equalZero = {
			zero: false,
			name: '',
		}
		for (let product of productsList) {
			if (product.quantity === 0) {
				equalZero = {
					zero: true,
					name: product.editable_name,
				}
				break
			}
		}
		if (equalZero.zero) {
			notification.error({
				message: equalZero.name,
				description: 'Este producto no posee una cantidad válida',
			})
			return
		}
		setGroupProduct((previousState) => [
			...previousState,
			{
				name: item.groupTitle,
				products: [...productsList],
			},
		])
		setProductsList([])
		form.setFieldsValue({
			groupTitle: '',
			searchInput: '',
		})
	}

	return (
		<>
			<Button
				onClick={() => props.setDigitalModal((pvSt) => ({ ...pvSt, confirm: true }))}
				type='primary'
				icon={<CheckOutlined />}
				className='ph-order-detail-actions-button-approve'>
				<span>Aprobar</span>
			</Button>
			<Modal
				title='Sube tu receta'
				visible={props.digitalModal.confirm}
				onCancel={() => props.setDigitalModal((pvSt) => ({ ...pvSt, confirm: false }))}
				footer={[
					<Button
						key='confirm'
						onClick={() =>
							groupProduct.length > 0 &&
							props.handleAproveOrRejectDigital(groupProduct, 'completed')
						}>
						Confirmar
					</Button>,
				]}>
				<Form form={form} name='add_group' onFinish={handleAddGroup}>
					<Form.Item
						name='groupTitle'
						rules={[{ required: true, message: 'Ingrese título del grupo' }]}>
						<Input type='text' placeholder='Nombre genérico' />
					</Form.Item>
					<Form.Item name='searchInput'>
						<Input
							type='text'
							onChange={handleSearchList}
							placeholder='Búsqueda en productos...'
							className={`ph-search-header-input-windows ph-search-header`}
						/>
					</Form.Item>
					{searchList.length > 0 && (
						<ul className='ph-search-header-list-main-container' style={{ display: 'block' }}>
							{searchList.map((item, index) => (
								<li
									className='ph-search-header-list'
									onClick={() => handleCleanList(item)}
									key={index}>
									<div className='ph-search-header-list-description'>
										<Row>
											<Col span={2} className='ph-search-header-images-search-content'>
												<ProductImage
													classContent={'ph-search-header-list-image-container'}
													classImage={'ph-search-header-list-image'}
													webp={`${process.env.REACT_APP_IMAGE_ROUTE}/products/${process.env.REACT_APP___COUNTRY}/600x600/${item.id_pharol}.webp`}
													//jp2={`${ENV_IMG_ROUTE}/products/${ENV_COUNTRY}/600x600/${props.item.id_pharol}.jp2`}
													//jxr={`${ENV_IMG_ROUTE}/products/${ENV_COUNTRY}/600x600/${props.item.id_pharol}.jxr`}
													default={`${process.env.REACT_APP_IMAGE_ROUTE}/products/${process.env.REACT_APP___COUNTRY}/600x600/${item.id_pharol}.png`}
													title={item.editable_name}
												/>
											</Col>
											<Col span={22} className='ph-search-header-titles-search-content'>
												<h3 className='ph-search-header-titles-search-h3'>{item.editable_name}</h3>
												{item.available >= 0 && (
													<p className='ph-search-header-titles-search-p'>
														Disponible en{' '}
														<span className='ph-search-header-titles-search-contents-p-span'>
															{item.available} Farmacias
														</span>
													</p>
												)}
											</Col>
										</Row>
									</div>
								</li>
							))}
						</ul>
					)}
					{productsList.length > 0 && (
						<>
							{productsList.map((item, index) => (
								<Row key={index} className='ph-search-product-selected-container'>
									<Col span={4}>
										<ProductImage
											classContent='ph-search-product-selected-image-container'
											classImage='ph-search-product-selected-image'
											default={item.image}
										/>
									</Col>
									<Col span={16}>
										<h3 className='ph-search-product-selected-title'>{item.editable_name}</h3>
										<p>Disponible en {item.available} farmacias</p>
									</Col>
									<Col span={4}>
										<div className='ph-search-product-selected-quantity-container'>
											<Button
												className='ph-search-product-selected-delete-quantity'
												onClick={() =>
													setProductsList((previousState) => {
														let products = [...previousState]
														products[index].quantity > 0 && products[index].quantity--
														return products
													})
												}>
												<LeftOutlined />
											</Button>
											<Input
												className='ph-search-product-selected-quantity-input'
												placeholder={item.quantity}
												disabled
											/>
											<Button
												className='ph-search-product-selected-add-quantity'
												onClick={() =>
													setProductsList((previousState) => {
														let products = [...previousState]
														products[index].quantity++
														return products
													})
												}>
												<RightOutlined />
											</Button>
										</div>
										<Button
											className='ph-search-product-remove-button'
											onClick={() => handleDeleteProduct(item)}
											icon={<DeleteFilled />}
										/>
									</Col>
								</Row>
							))}
							<Button htmlType='submit'>Agregar</Button>
						</>
					)}
					{groupProduct.length > 0 &&
						groupProduct.map((group, index) => (
							<React.Fragment key={index}>
								<h4 className='ph-search-product-group-title'>{group.name}</h4>
								{group.products.map((insideProducts, imageIndex) => (
									<Image key={imageIndex} src={insideProducts.image} width={90} />
								))}
							</React.Fragment>
						))}
				</Form>
			</Modal>
		</>
	)
}
